import React, { useContext, useEffect, useState } from 'react';
import { getHCPCScode } from '@mummssoftware/utils/hcpcsUtils';
import { HCPCSContext } from '../Context/contexts/HCPCSContext';
import { SET_HCPCS_CODE_MAP } from '../Context/constants';
import { HCPCSTitle } from '../../components';

type HCPCSCodeProps = {
  hcpcsChoice: mumms.HCPCSMenuItem;
};

export const HCPCSCode = ({ hcpcsChoice }: HCPCSCodeProps) => {
  const { hcpcsDuration, dispatchHCPCS, hcpcsCodesMap } = useContext(
    HCPCSContext,
  );
  const [code, setCode] = useState<{
    uiCode: string;
    hcpcsCode: string[];
  } | null>(null);

  const durationForChoice = hcpcsDuration && hcpcsDuration[hcpcsChoice.key];
  // After RESET_HCPCS_FOR_RELOAD the map is cleared but duration may be unchanged,
  // so the effect must also re-run when mapped codes for this key disappear.
  const mappedCodes = hcpcsCodesMap && hcpcsCodesMap[hcpcsChoice.key];

  useEffect(() => {
    if (!durationForChoice) {
      return;
    }
    if (hcpcsChoice.rules && Object.keys(hcpcsChoice.rules).length) {
      const hcpcsRules = hcpcsChoice.rules;
      const codeMap = getHCPCScode(durationForChoice, hcpcsRules, hcpcsChoice);
      setCode(codeMap);
      if (codeMap) {
        const nextCodes = codeMap.hcpcsCode;
        const same =
          Array.isArray(mappedCodes) &&
          mappedCodes.length === nextCodes.length &&
          mappedCodes.every((c, i) => c === nextCodes[i]);
        if (!same) {
          dispatchHCPCS({
            type: SET_HCPCS_CODE_MAP,
            payload: { key: hcpcsChoice.key, codes: nextCodes },
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [durationForChoice, hcpcsChoice.key, mappedCodes, dispatchHCPCS]);

  return code && code.uiCode ? (
    <div id="hcpcs-code">
      <HCPCSTitle>{code.uiCode}</HCPCSTitle>
    </div>
  ) : (
    <></>
  );
};
